import { render } from "./Index.vue?vue&type=template&id=261edd02&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=261edd02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-261edd02"

export default script